import React from 'react';
import classNames from 'classnames';
import { Tag as AntdTag } from 'antd';
import { TagProps as AntdTagProps } from 'antd/lib/tag';
import styles from './tag.module.scss';

export enum TagType {
	beta = 'beta',
	new = 'new',
	soon = 'soon',
	readOnly = 'readOnly',
	info = 'info',
	danger = 'danger',
	warning = 'warning',
	success = 'success'
}

interface TagProps extends AntdTagProps {
	type?: TagType;
	circle?: boolean;
}

const Tag: React.FC<TagProps> = ({ className, type, circle, ...tagProps }: TagProps) => {
	const commonClass = styles[type];

	const combinedClassName = classNames('bringg-tag', className, styles.bringgTag, commonClass, {
		[styles.circle]: !!circle
	});
	return <AntdTag className={combinedClassName} {...tagProps} />;
};

export default Tag;
